module.exports = __webpack_public_path__ + "img/SUMMERGATE_background.8f59b801.png";